import { client } from "@/store/client.js";
import axios from "axios";

export const namespaced = true;

export const state = {	
	orders: null
};

export const actions = {
    getPayments() {
        return client.coreapi.get('/getpayments')
           .then(r => {
             console.log(r.data)
             return r.data;
             //this.invoices = data;
           })
     },
}